/* ============
 * Edit Page
 * ============
 *
 * This page edits subscriberList.
 */

import { mapGetters, mapMutations } from 'vuex';
import subscriberListService from './../../../../services/subscriberList';
import subscriberService from './../../../../services/subscriber';
import subscriberListTransformer from './../../../../transformers/subscriberList';
import publicProfileService from './../../../../services/publicProfile';
import clientService from './../../../../services/client';
import clientGroupService from './../../../../services/client-group';
import clientGroupModal from './../../../../components/clientGroupModal/clientGroupModal.vue';
import Forms from './../../../../utils/forms/forms';
import accountService from './../../../../services/account';

export default {
  data() {
    return {
      form: new Forms({
        name: {
          value: '',
          type: 'text',
        },
        selectDefaultEmail: {
          value: 'true',
          type: 'checkbox',
        },
        fromEmail: {
          value: '',
          type: 'email',
        },
        selectDefaultName: {
          value: 'true',
          type: 'checkbox',
        },
        fromName: {
          value: '',
          type: 'text',
        },
        description: {
          value: '',
          type: 'textarea',
        },
        doubleOptinRequired: {
          value: 1,
          type: 'switch',
        },
        optinEmailSubject: {
          value: '',
          type: 'text',
        },
        optinEmailBody: {
          value: '',
          type: 'textarea',
        },
      }),
      selectedRule: '',
      ruleOptions: [
        { id: 'clientGroupIds', name: 'ClientGroup' },
      ],
      selectedRuleClientGroups: [],
      allRuleClientGroups: [],
      populateRules: [],
      selectedClientGroupsLoading: false,
      defaultName: '',
      defaultEmail: '',
      tempName: '',
      tempEmail: '',
      activeName: '1',
      subscribers: {},
      allClients: [],
      allClientGroups: [],
      selectedClients: [],
      selectedClientGroups: [],
      newSelectedClientGroups: [],
      selectClientError: '',
      selectClientGroupError: '',
      addingClients: false,
      addingClientGroups: false,
      loading: false,
      loadingClients: false,
      loadingClientsGroup: false,
      loadingSubscribers: false,
      tempDataHolder: [],
      tempIdHolder: [],
      subscribeSwitchData: [],
      filter: 'all',
      FilterTypes: [
        { id: 'all', name: this.$t('static.subscriberList.edit.filters.all') },
        { id: 'unsubscribed', name: this.$t('static.subscriberList.edit.filters.unsubscribe') },
      ],
      sendingEmailsLoading: false,
      optinEmailSubjectHolder: '',
      optinEmailBodyHolder: '',
      limit: 25,
    };
  },

  computed: {
    ...mapGetters({
      subscriberList: 'subscriberList',
      subscriber: 'subscriber',
      modifiedClientGroup: 'modifiedClientGroup',
      cancelClientGroupAdd: 'cancelClientGroupAdd',
    }),

    allClientsList() {
      return this.allClients.map(c => (
        { id: c.id, name: c.name || `${c.firstName} ${c.lastName}`, disabled: c.disabled }
      ));
    },
  },

  watch: {

    /**
     * Watch double optin switch.
     *
     * @param  {Boolean} value Checked or not.
     */
    'form.doubleOptinRequired': function (value) {
      if (value) {
        this.addRemoveFields(true);
      } else {
        this.addRemoveFields(false);
      }
    },

    /**
     * Watch selectDefaultName checkbox.
     *
     * @param  {Boolean} value Checked or not.
     */
    'form.selectDefaultName': function (value) {
      if (value) {
        this.setThefield('fromName', this.defaultName, 'disable');
      } else {
        this.setThefield('fromName', this.tempName, 'enable');
      }
    },

    /**
     * Watch selectDefaultName checkbox.
     *
     * @param  {Boolean} value Checked or not.
     */
    'form.selectDefaultEmail': function (value) {
      if (value) {
        this.setThefield('fromEmail', this.defaultEmail, 'disable');
      } else {
        this.setThefield('fromEmail', this.tempEmail, 'enable');
      }
    },

    /**
     * Watch client group
     */
    selectedClientGroups(newVal, oldVal) {
      if (newVal.length > oldVal.length) {
        const self = this;
        setTimeout(() => {
          self.subscriberList.currentClientGroup = newVal[newVal.length - 1];
          self.clientGroupModal();
        }, 500);
      } else {
        //
      }
    },

    modifiedClientGroup(modifiedClientGroup) {
      const key = this.subscriberList.currentClientGroup;
      this.tempDataHolder.push({ group: key, items: modifiedClientGroup.items });

      const self = this;
      modifiedClientGroup.items.forEach((item) => {
        if (item.status === true) {
          self.newSelectedClientGroups.push(item.id);
        }
      });
    },

    cancelClientGroupAdd(cancelClientGroupAdd) {
      if (cancelClientGroupAdd.items === true) {
        this.selectedClientGroups.pop();
      }
    },

    selectedRule(value) {
      if (value === 'clientGroupIds') {
        const rules = this.populateRules.rules.map(item => ({ id: item.id, name: item.name }));
        this.allRuleClientGroups = rules;
        this.selectedRuleClientGroups = rules.map(item => (item.id.toString()));
      }
    },

    $route() {
      this.urlCurrentTab();
    },

    activeName(value) {
      this.assignTab(value);
    },
  },

  mounted() {
    this.urlCurrentTab();
    this.assignTab(this.activeName);
    this.show();
  },


  methods: {
    ...mapMutations({
      toggleModal: 'TOGGLE_MODAL',
      setModalContent: 'SET_MODAL_CONTENT',
      setModalCloseOnClick: 'SET_MODAL_CLOSE_ON_CLICK',
      setModalShowClose: 'SET_MODAL_SHOW_CLOSE',
      setModalCloseOnPressEscape: 'SET_MODAL_CLOSE_ON_PRESS_ESCAPE',
      unsetModalContent: 'UNSET_MODAL_CONTENT',
    }),

    activateSubscriber(type) {
      const message = (type) ? this.$t('static.subscriberList.edit.subscribers.subscribe') : this.$t('static.subscriberList.edit.subscribers.unsubscribe');
      const warningMsg = (type) ? this.$t('static.subscriberList.edit.subscribers.ableToReceiveAll') : this.$t('static.subscriberList.edit.subscribers.unableToReceiveAll');
      this.$confirm(warningMsg, this.$t('static.subscriberList.edit.subscribers.subscribeConfirmHeaderMsg'), {
        confirmButtonText: message,
        cancelButtonText: this.$t('button.cancel'),
        type: 'warning',
      }).then(() => {
        subscriberService.subscribeSwitchAll({ list_id: this.$route.params.id, status: !type }).then(() => {
          this.fetchSubscriber(this.subscribers.pagination.currentPage, this.limit);
          this.$message({
            message: `${message} successfully`,
            type: 'success',
          });
        }).catch((errors) => {
          console.log(errors);
          this.$message({
            message: 'Something went wrong!',
            type: 'error',
          });
        });
      }).catch(() => {
        console.log('go back');
      });
    },

    assignTab(value) {
      let tab = '';
      if (value == '3') {
        tab = '#rules';
      } else if (value == '2') {
        tab = '#settings';
      } else {
        tab = '#subscribers';
      }
      history.pushState({}, null, `/#${this.$route.path}${tab}`);
    },

    urlCurrentTab() {
      if (this.$router.currentRoute.hash == '#rules') {
        this.activeName = '3';
      } else if (this.$router.currentRoute.hash == '#settings') {
        this.activeName = '2';
      } else {
        this.activeName = '1';
      }
    },

    onChangeRulesByGroup(name, value) {
      this[name] = value;
    },

    saveRule() {
      this.selectedClientGroupsLoading = true;
      const converted = this.selectedRuleClientGroups.map(item => parseInt(item));
      subscriberListService.storeRules(this.$route.params.id, { rules: this.selectedRule, groups: converted }).then(() => {
        this.form.loading = false;
        this.$message({
          message: 'Save successfully',
          type: 'success',
        });
        this.selectedClientGroupsLoading = false;
      }).catch((errors) => {
        this.selectedClientGroupsLoading = false;
      });
    },

    perPage(size) {
      accountService.rememberPerPage('post', { from: 'subscriber_list', perPage: size })
      .then((data) => {
        this.limit = data.size;
      }).catch((error) => {
        console.log(error);
      });
    },

    selectClientRemote(query) {
      if (query !== '') {
        this.fetchClients(query);
      }
    },

    selectClientGroupRemote(query) {
      if (query !== '') {
        this.fetchClientGroups(query);
      }
    },

    selectRuleClientGroupRemote(query) {
      if (query !== '') {
        this.fetchClientGroups(query, 'rules');
      }
    },

    /**
     * Dynamically add new fields
     */
    addRemoveFields(status) {
      if (status === true) {
        this.form.setFieldValue('optinEmailSubject', this.optinEmailSubjectHolder);
        this.form.setFieldValue('optinEmailBody', this.optinEmailBodyHolder);
        this.form.showField('optinEmailSubject');
        this.form.showField('optinEmailBody');
        this.form.clearErrors('optinEmailSubject');
        this.form.clearErrors('optinEmailBody');
      } else {
        this.form.hideField('optinEmailSubject');
        this.form.hideField('optinEmailBody');
      }
    },

     /**
     * Activates the modal
     */
    clientGroupModal() {
      this.setModalContent(() => clientGroupModal);
      this.setModalCloseOnClick(false);
      this.setModalShowClose(false);
      this.setModalCloseOnPressEscape(false);
      this.toggleModal(true);
    },

    /**
     * Show subscriberList
     */
    show() {
      this.loading = true;
      Promise.all([
        subscriberListService.show(this.$route.params.id),
        subscriberService.all(this.$route.params.id),
        subscriberListService.showRules(this.$route.params.id),
      ]).then((data) => {
        this.populateRules = data[2];
        accountService.rememberPerPage('get', { from: 'subscriber_list' })
        .then((data2) => {
          this.limit = data2.size;
          this.fetchSubscriber(1, this.limit);
        }).catch((error) => {
          console.log(error);
        });

        this.form.assignData(this.subscriberList.current);

        const self = this;
        publicProfileService.show().then((data2) => {
          self.defaultName = data2.orgName;
          self.defaultEmail = data2.orgEmail;

          if (self.defaultName === self.form.fromName) {
            self.setThefield('fromName', self.defaultName, 'disable');
          } else {
            self.tempName = self.form.fromName;
            self.form.selectDefaultName = '';
          }

          if (self.defaultEmail === self.form.fromEmail) {
            self.setThefield('fromEmail', self.defaultEmail, 'disable');
          } else {
            self.tempEmail = self.form.fromEmail;
            self.form.selectDefaultEmail = '';
          }
          this.loading = false;

          this.optinEmailSubjectHolder = this.form.optinEmailSubject;
          this.optinEmailBodyHolder = this.form.optinEmailBody;
          if (this.form.doubleOptinRequired === 0) {
            this.optinEmailSubjectHolder = data.optinEmailSubject;
            this.optinEmailBodyHolder = data.optinEmailBody;
          }
          this.form.setFieldValue('optinEmailSubject', this.optinEmailSubjectHolder);
          this.form.setFieldValue('optinEmailBody', this.optinEmailBodyHolder);
        }).catch((err) => {
          console.log(err);
        });
      });
    },

    /**
    * field interaction
    * @param {*} name
    * @param {*} value
    * @param {*} status
    */
    setThefield(name, value, status) {
      if (status === 'disable') {
        this.form.disableField(name);
      } else if (status === 'enable') {
        this.form.enableField(name);
      }
      this.form.setFieldValue(name, value);
    },

    /**
     * Update the subscriberList
     */
    update() {
      this.form.loading = true;
      const subscriberList = subscriberListTransformer.send(this.form.data());
      subscriberListService.update(this.$route.params.id, subscriberList).then(() => {
        this.form.loading = false;
        this.$message({
          message: 'Update successfully',
          type: 'success',
        });
      }).catch((errors) => {
        this.form.loading = false;
        this.form.recordErrors(errors);
      });
    },

    /**
     * Delete the subscriberList
     */
    destroy() {
      this.$confirm(this.$t('static.subscriberList.edit.deleteConfirmBodyMsg'), this.$t('static.subscriberList.edit.deleteConfirmHeaderMsg'), {
        confirmButtonText: this.$t('static.subscriberList.edit.delete'),
        cancelButtonText: this.$t('button.cancel'),
        type: 'warning',
      }).then(() => {
        this.form.loading = true;
        subscriberListService.destroy(this.$route.params.id).then(() => {
          this.form.loading = false;
          this.$message({
            message: 'Delete successfully',
            type: 'success',
          });
          this.$router.push({
            name: 'subscriberList.index',
          });
        }).catch((errors) => {
          this.form.loading = false;
          this.form.recordErrors(errors);
        });
      }).catch(() => {});
    },

    onChange(name, value) {
      this[name] = value;
      if (name === 'selectedClientGroups' && this.tempIdHolder.length > value.length) {
        const group = this.tempIdHolder.filter(obj => value.indexOf(obj) === -1)[0];

        const self = this;
        this.tempIdHolder = value;
        this.tempDataHolder.forEach((item) => {
          if (item.group === group) {
            item.items.forEach((item2) => {
              self.newSelectedClientGroups = self.newSelectedClientGroups.filter(e => e !== item2.id);
            });
            return;
          }
        });
      }
    },

    /**
     * Get all clients.
     */
    fetchClients(remoteSearch = null) {
      const self = this;
      this.loadingClients = true;
      clientService.all(remoteSearch)
      .then((clients) => {
        self.allClients = [];
        clients.forEach((item) => {
          item.contacts.forEach((item2) => {
            self.subscriber.items.forEach((item3) => {
              if (item3.contact_id === item2.id) {
                item2.exist = true;
              }
            });
            const type = (item2.contact_types.length > 0) ? item2.contact_types[0].name : 'Primary';
            this.allClients.push({
              id: item2.id,
              name: `${item.name} - ${item2.email}(${type})${(item2.exist) ? this.$t('static.subscriberList.edit.subscribers.alreadyInList') : ''}`,
              disabled: !!(item2.exist),
            });
          });
        });
        this.loadingClients = false;
      });
    },

    /**
     * Get all client groups.
     */
    fetchClientGroups(remoteSearch = null, type = null) {
      this.loadingClientsGroup = true;
      this.allClientGroups = [];
      clientGroupService.all(remoteSearch).then((groups) => {
        if (type === 'rules') {
          this.allRuleClientGroups = groups;
        } else {
          this.allClientGroups = groups;
        }
        this.loadingClientsGroup = false;
      });
    },


    /**
     * Delete the subscriber
     */
    deleteSubscriber(id) {
      this.$confirm(this.$t('static.subscriberList.edit.subscribers.deleteConfirmBodyMsg'), this.$t('static.subscriberList.edit.subscribers.deleteConfirmHeaderMsg'), {
        confirmButtonText: this.$t('static.subscriberList.edit.subscribers.delete'),
        cancelButtonText: this.$t('button.cancel'),
        type: 'warning',
      }).then(() => {
        subscriberService.destroy(id).then((response) => {
          this.fetchSubscriber(this.subscribers.pagination.currentPage, this.limit);
          this.$message({
            message: 'Delete successfully',
            type: 'success',
          });
          this.autoDisableEnabled(response.contact_id, 'remove');
          // this.fetchClientGroups();
          // this.fetchClients();
        }).catch((errors) => {
          console.log(errors);
        });
      }).catch(() => {});
    },

    /**
     * Get subscribers.
     */
    fetchSubscriber(page, limit) {
      this.loadingSubscribers = true;
      subscriberService.items(this.$route.params.id, page, limit, this.filter).then((subscribers) => {
        this.subscribers = subscribers;
        this.loadingSubscribers = false;
        this.subscribeSwitchSet();
      });
    },

    /**
     * Auto disabled and enable emails after add or delete
     *
     */
    autoDisableEnabled(ids, type) {
      const self = this;
      if (type === 'add') {
        ids.forEach((item) => {
          self.allClients.forEach((item2) => {
            if (parseInt(item) === item2.id) {
              item2.disabled = true;
            }
          });
        });
      } else if (type === 'remove') {
        self.allClients.forEach((item2) => {
          if (parseInt(ids) === item2.id) {
            item2.disabled = false;
          }
        });
      }
    },

    /**
     * Add clients email to subscriber list
     */
    addClients(groups = false) {
      this.sendingEmailsLoading = true;
      const data = !groups ?
      { contacts: this.selectedClients } :
      { contacts: this.newSelectedClientGroups };
      if (!groups) {
        this.addingClients = true;
      } else {
        this.addingClientGroups = true;
      }
      subscriberService.store(this.$route.params.id, data)
      .then(() => {
        this.$message({
          message: `${data.contacts.length} email(s) successfully added to list`,
          type: 'success',
        });
        this.fetchSubscriber(this.subscribers.pagination.currentPage, this.limit);
        this.autoDisableEnabled(data.contacts, 'add');
        this.addingClients = false;
        this.addingClientGroups = false;
        this.sendingEmailsLoading = false;
        this.selectedClients = [];
        this.newSelectedClientGroups = [];
        this.selectedClientGroups = [];
      }).catch((errors) => {
        this.$message({
          message: 'Something went wrong!',
          type: 'error',
        });
        console.log(errors);
        this.addingClients = false;
        this.addingClientGroups = false;
        this.sendingEmailsLoading = false;
      });
    },

    subscribeSwitch(id) {
      const action = this.subscribeSwitchData[id];
      const message = (action === 1) ? this.$t('static.subscriberList.edit.subscribers.subscribe') : this.$t('static.subscriberList.edit.subscribers.unsubscribe');
      const warningMsg = (action === 1) ? this.$t('static.subscriberList.edit.subscribers.ableToReceive') : this.$t('static.subscriberList.edit.subscribers.unableToReceive');
      this.$confirm(warningMsg, this.$t('static.subscriberList.edit.subscribers.subscribeConfirmHeaderMsg'), {
        confirmButtonText: message,
        cancelButtonText: this.$t('button.cancel'),
        type: 'warning',
      }).then(() => {
        subscriberService.subscribeSwitch(id, { status: action === 0 }).then((email) => {
          this.fetchSubscriber(this.subscribers.pagination.currentPage, this.limit);
          this.$message({
            message: `${email} ${message} successfully`,
            type: 'success',
          });
        }).catch((errors) => {
          console.log(errors);
          this.$message({
            message: 'Something went wrong!',
            type: 'error',
          });
        });
      }).catch(() => {
        console.log('go back');
      });
    },

    subscribeSwitchSet() {
      this.subscribers.subscriber.forEach((item) => {
        this.subscribeSwitchData[item.id] = item.subscribe;
      });
    },

    onChangeFilter(filter) {
      this.filter = (filter === 'all') ? 'unsubscribed' : 'all';
      this.fetchSubscriber(1, this.limit);
    },
  },

  components: {
    VForm: require('./../../../../components/form/form.vue'),
    VSelect: require('./../../../../components/form/select/select.vue'),
    VPagination: require('./../../../../components/paginationNew/paginationNew.vue'),
  },
};



// WEBPACK FOOTER //
// ./src/app/pages/withNavigation/subscriberList/edit/edit.js